// //client/src/pages/invoice/CompletedPage.jsx
// import React from "react";

// export default function CompletedPage({ result }) {

  

//   const handleDownload = () => {
//     if (!result?.downloadUrl) return;

//     const link = document.createElement("a");
//     link.href = result.downloadUrl;
//     link.setAttribute("download", "");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div className="page-wrap">

//       <header className="topbar fixed-header">
//         <div className="brand">
//           <span className="logo">📄</span>

//           <div>
//             <div className="title">
//               SISL Invoice Processor
//             </div>

//             <div className="subtitle">
//               Invoice Intelligence
//             </div>
//           </div>
//         </div>

//         <div className="status">
//           <span className="dot" />
//           System Online
//         </div>
//       </header>

//       <main
//         className="center"
//         style={{ paddingTop: "90px" }}
//       >
//         <div className="card complete-card">

//           <div className="success-icon">
//             ✔
//           </div>

//           <h1>
//             Processing Complete
//           </h1>

//           <p className="desc">
//             Invoice processing finished successfully
//           </p>

//           {/* =========================
//               SUMMARY CARDS
//           ========================= */}

//           <div className="summary-grid">

//             <div className="summary-item">
//               <h3>
//                 {result?.totalUploaded || 0}
//               </h3>
//               <span>
//                 Uploaded
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result?.validInvoices || 0}
//               </h3>
//               <span>
//                 Processed
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result?.duplicateInvoices || 0}
//               </h3>
//               <span>
//                 Duplicates
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result?.unreadableInvoices || 0}
//               </h3>
//               <span>
//                 Unreadable
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result?.invalidInvoices || 0}
//               </h3>
//               <span>
//                 Invalid
//               </span>
//             </div>

//           </div>

//           {/* =========================
//               DOWNLOAD
//           ========================= */}

//           <button
//             type="button"
//             className="primary-btn"
//             onClick={handleDownload}
//           >
//             Download Invoice Excel
//           </button>

//           {/* =========================
//               ERROR SECTION
//           ========================= */}

//           {result?.errors?.length > 0 && (

//             <div className="error-section">

//               <h3>
//                 Processing Errors
//               </h3>

//               <table className="error-table">

//                 <thead>
//                   <tr>
//                     <th>File</th>
//                     <th>Invoice</th>
//                     <th>Vendor</th>
//                     <th>Reason</th>
//                   </tr>
//                 </thead>

//                 <tbody>

//                   {result.errors.map(
//                     (error, index) => (
//                       <tr key={index}>
//                         <td>
//                           {error.file_name}
//                         </td>

//                         <td>
//                           {error.invoice_number}
//                         </td>

//                         <td>
//                           {error.vendor}
//                         </td>

//                         <td>
//                           {error.reason}
//                         </td>
//                       </tr>
//                     )
//                   )}

//                 </tbody>

//               </table>

//             </div>
//           )}

//         </div>
//       </main>
//     </div>
//   );
// }



// //client/src/pages/invoice/CompletedPage.jsx

// import React from "react";
// import { useLocation } from "react-router-dom";

// export default function CompletedPage() {

//   const location = useLocation();

//   const result =
//     location.state?.result || {};

//   console.log("RESULT:", result);

//   const handleDownload = () => {

//     if (!result?.downloadUrl) return;

//     const link =
//       document.createElement("a");

//     link.href =
//       result.downloadUrl;

//     link.setAttribute(
//       "download",
//       ""
//     );

//     document.body.appendChild(
//       link
//     );

//     link.click();

//     document.body.removeChild(
//       link
//     );
//   };

//   return (
//     <div className="page-wrap">

//       <header className="topbar fixed-header">

//         <div className="brand">

//           <span className="logo">
//             📄
//           </span>

//           <div>

//             <div className="title">
//               SISL Invoice Processor
//             </div>

//             <div className="subtitle">
//               Invoice Intelligence
//             </div>

//           </div>

//         </div>

//         <div className="status">
//           <span className="dot" />
//           System Online
//         </div>

//       </header>

//       <main
//         className="center"
//         style={{
//           paddingTop: "90px",
//         }}
//       >

//         <div className="card complete-card">

//           <div className="success-icon">
//             ✔
//           </div>

//           <h1>
//             Processing Complete
//           </h1>

//           <p className="desc">
//             Invoice processing finished successfully
//           </p>

//           {/* SUMMARY */}

//           <div className="summary-grid">

//             <div className="summary-item">
//               <h3>
//                 {result.totalUploaded || 0}
//               </h3>
//               <span>
//                 Uploaded
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result.validInvoices || 0}
//               </h3>
//               <span>
//                 Processed
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result.duplicateInvoices || 0}
//               </h3>
//               <span>
//                 Duplicates
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result.unreadableInvoices || 0}
//               </h3>
//               <span>
//                 Unreadable
//               </span>
//             </div>

//             <div className="summary-item">
//               <h3>
//                 {result.invalidInvoices || 0}
//               </h3>
//               <span>
//                 Invalid
//               </span>
//             </div>

//           </div>

//           {/* DOWNLOAD */}

//           <button
//             type="button"
//             className="primary-btn"
//             onClick={handleDownload}
//           >
//             Download Invoice Excel
//           </button>

//           {/* ERRORS */}

//           {result.errors &&
//             result.errors.length > 0 && (

//             <div className="error-section">

//               <h3>
//                 Processing Errors
//               </h3>

//               <table className="error-table">

//                 <thead>

//                   <tr>
//                     <th>File</th>
//                     <th>Invoice</th>
//                     <th>Vendor</th>
//                     <th>Reason</th>
//                   </tr>

//                 </thead>

//                 <tbody>

//                   {result.errors.map(
//                     (error, index) => (

//                       <tr key={index}>

//                         <td>
//                           {error.file_name}
//                         </td>

//                         <td>
//                           {error.invoice_number}
//                         </td>

//                         <td>
//                           {error.vendor}
//                         </td>

//                         <td>
//                           {error.reason}
//                         </td>

//                       </tr>

//                     )
//                   )}

//                 </tbody>

//               </table>

//             </div>

//           )}

//         </div>

//       </main>

//     </div>
//   );
// }


// //client/src/pages/invoice/CompletedPage.jsx
// import React from "react";
// import {
//   useLocation,
//   useNavigate,
// } from "react-router-dom";

// export default function CompletedPage() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const result =
//     location.state?.result || {};

//   const handleDownload = () => {
//     if (!result?.downloadUrl) return;

//     const link =
//       document.createElement("a");

//     link.href =
//       result.downloadUrl;

//     link.setAttribute(
//       "download",
//       ""
//     );

//     document.body.appendChild(link);

//     link.click();

//     document.body.removeChild(link);
//   };

//   return (
//     <div className="page-wrap">

//       {/* HEADER */}

//       <header className="topbar fixed-header">

//         <div className="brand">

//           <span className="logo">
//             📄
//           </span>

//           <div>

//             <div className="title">
//               SISL Invoice Processor
//             </div>

//             <div className="subtitle">
//               Invoice Intelligence
//             </div>

//           </div>

//         </div>

//         <div className="status">
//           <span className="dot" />
//           System Online
//         </div>

//       </header>

//       <main
//         className="center"
//         style={{
//           paddingTop: "90px",
//         }}
//       >

//         <div
//           className="card complete-card"
//           style={{
//             maxWidth: "1200px",
//             width: "100%",
//           }}
//         >

//           {/* SUCCESS */}

//           <div
//             style={{
//               textAlign: "center",
//               marginBottom: "30px",
//             }}
//           >

//             <div className="success-icon">
//               ✔
//             </div>

//             <h1>
//               Processing Complete
//             </h1>

//             <p className="desc">
//               Invoice processing completed successfully
//             </p>

//           </div>

//           {/* SUMMARY CARDS */}

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns:
//                 "repeat(auto-fit,minmax(180px,1fr))",
//               gap: "16px",
//               marginBottom: "30px",
//             }}
//           >

//             <div className="summary-card">
//               <h2>
//                 {result.totalUploaded || 0}
//               </h2>
//               <span>Uploaded</span>
//             </div>

//             <div className="summary-card">
//               <h2>
//                 {result.validInvoices || 0}
//               </h2>
//               <span>Processed</span>
//             </div>

//             <div className="summary-card">
//               <h2>
//                 {result.duplicateInvoices || 0}
//               </h2>
//               <span>Duplicates</span>
//             </div>

//             <div className="summary-card">
//               <h2>
//                 {result.unreadableInvoices || 0}
//               </h2>
//               <span>Unreadable</span>
//             </div>

//             <div className="summary-card">
//               <h2>
//                 {result.invalidInvoices || 0}
//               </h2>
//               <span>Invalid</span>
//             </div>

//           </div>

//           {/* ACTIONS */}

//           <div
//             style={{
//               display: "flex",
//               gap: "12px",
//               justifyContent: "center",
//               marginBottom: "30px",
//             }}
//           >

//             <button
//               className="primary-btn"
//               onClick={handleDownload}
//             >
//               Download Invoice Excel
//             </button>

//             <button
//               className="secondary-btn"
//               onClick={() =>
//                 navigate("/", {
//                   replace: true,
//                 })
//               }
//             >
//               Back To Dashboard
//             </button>

//           </div>

//           {/* ERRORS */}

//           {result.errors &&
//             result.errors.length > 0 && (

//             <div
//               style={{
//                 marginTop: "30px",
//               }}
//             >

//               <h2
//                 style={{
//                   marginBottom: "20px",
//                 }}
//               >
//                 Processing Errors
//               </h2>

//               <div
//                 style={{
//                   maxHeight: "450px",
//                   overflowY: "auto",
//                   border:
//                     "1px solid #e5e7eb",
//                   borderRadius: "12px",
//                 }}
//               >

//                 <table
//                   className="error-table"
//                   style={{
//                     width: "100%",
//                     borderCollapse:
//                       "collapse",
//                   }}
//                 >

//                   <thead
//                     style={{
//                       position: "sticky",
//                       top: 0,
//                       background: "#fff",
//                       zIndex: 10,
//                     }}
//                   >

//                     <tr>

//                       <th>File Name</th>

//                       <th>
//                         Invoice Number
//                       </th>

//                       <th>
//                         Vendor
//                       </th>

//                       <th>
//                         Reason
//                       </th>

//                     </tr>

//                   </thead>

//                   <tbody>

//                     {result.errors.map(
//                       (
//                         error,
//                         index
//                       ) => (

//                         <tr
//                           key={index}
//                         >

//                           <td>
//                             {
//                               error.file_name
//                             }
//                           </td>

//                           <td>
//                             {
//                               error.invoice_number
//                             }
//                           </td>

//                           <td>
//                             {
//                               error.vendor
//                             }
//                           </td>

//                           <td>
//                             {
//                               error.reason
//                             }
//                           </td>

//                         </tr>

//                       )
//                     )}

//                   </tbody>

//                 </table>

//               </div>

//             </div>

//           )}

//         </div>

//       </main>

//     </div>
//   );
// }


// client/src/pages/invoice/CompletedPage.jsx

import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function CompletedPage() {

  const location = useLocation();
  const navigate = useNavigate();
  const result   = location.state?.result || {};

  // ── HEADER SCROLL ──
  const [hidden, setHidden]     = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 8);
      if (y > lastY.current && y > 120) setHidden(true);
      else setHidden(false);
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ── DOWNLOAD ──
  const handleDownload = () => {
    if (!result?.downloadUrl) return;
    const link = document.createElement("a");
    link.href = result.downloadUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const stats = [
    { value: result.totalUploaded      || 0, label: "Uploaded",   color: "#111827", bg: "#f9fafb", border: "#f3f4f6" },
    { value: result.validInvoices      || 0, label: "Processed",  color: "#15803d", bg: "#f0fdf4", border: "#bbf7d0" },
    { value: result.duplicateInvoices  || 0, label: "Duplicates", color: "#b45309", bg: "#fffbeb", border: "#fde68a" },
    { value: result.unreadableInvoices || 0, label: "Unreadable", color: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
    { value: result.invalidInvoices    || 0, label: "Invalid",    color: "#7c3aed", bg: "#f5f3ff", border: "#ddd6fe" },
  ];

  const hasErrors = result.errors && result.errors.length > 0;

  return (
    <div style={styles.page}>

      {/* ── HEADER ── */}
      <header style={{
        ...styles.header,
        ...(scrolled ? styles.headerScrolled : {}),
        ...(hidden   ? styles.headerHidden   : {}),
      }}>
        <div style={styles.headerInner}>
          <div style={styles.brand}>
            <div style={styles.logoWrap}>📄</div>
            <div>
              <div style={styles.brandTitle}>PSBS Invoice Processor</div>
              <div style={styles.brandSubtitle}>Invoice Intelligence</div>
            </div>
          </div>

          <div style={styles.statusPill}>
            <span style={styles.statusDot} />
            <span style={styles.statusText}>System Online</span>
          </div>
        </div>
      </header>

      {/* ── MAIN ── */}
      <main style={styles.main}>

        {/* PAGE HEADER */}
        <div style={styles.pageHeader}>
          <div style={styles.eyebrowRow}>
            <span style={styles.eyebrowDot} />
            <span style={styles.eyebrow}>Invoice</span>
            <span style={styles.eyebrowSep}>/</span>
            <span style={styles.eyebrowMuted}>Completed</span>
          </div>
          <h1 style={styles.pageTitle}>Processing Complete</h1>
          <p style={styles.pageSubtitle}>
            Invoice extraction finished successfully — review results and download your output sheet
          </p>
        </div>

        {/* ── SUCCESS BANNER ── */}
        <div style={styles.successBanner}>
          <div style={styles.successIconWrap}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <div>
            <div style={styles.successTitle}>All files have been processed</div>
            <div style={styles.successHint}>Your Excel output is ready to download</div>
          </div>
          <div style={styles.bannerActions}>
            <button style={styles.downloadBtn} onClick={handleDownload}>
              ↓ Download Invoice Excel
            </button>
            <button style={styles.secondaryBtn} onClick={() => navigate("/", { replace: true })}>
              Back to Dashboard
            </button>
          </div>
        </div>

        {/* ── STATS GRID ── */}
        <div style={styles.statsGrid}>
          {stats.map((s) => (
            <div key={s.label} style={{ ...styles.statCard, backgroundColor: s.bg, borderColor: s.border }}>
              <span style={{ ...styles.statValue, color: s.color }}>{s.value}</span>
              <span style={styles.statLabel}>{s.label}</span>
            </div>
          ))}
        </div>

        {/* ── ERRORS TABLE ── */}
        {hasErrors && (
          <div style={styles.errorSection}>

            {/* Section header */}
            <div style={styles.errorSectionHeader}>
              <div style={styles.sectionHeaderLeft}>
                <div style={{ ...styles.iconWrap, backgroundColor: "#fef2f2" }}>
                  <span style={{ fontSize: "16px" }}>⚠️</span>
                </div>
                <div>
                  <div style={styles.cardTitle}>Processing Errors</div>
                  <div style={styles.cardSubtitle}>
                    {result.errors.length} file{result.errors.length !== 1 ? "s" : ""} could not be processed
                  </div>
                </div>
              </div>
              <span style={styles.errorCount}>{result.errors.length}</span>
            </div>

            <div style={styles.divider} />

            {/* Table */}
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>File Name</th>
                    <th style={styles.th}>Invoice Number</th>
                    <th style={styles.th}>Vendor</th>
                    <th style={styles.th}>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {result.errors.map((error, i) => (
                    <tr key={i} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td style={styles.td}>
                        <span style={styles.fileCell}>
                          <span style={{ fontSize: "12px" }}>📄</span>
                          {error.file_name}
                        </span>
                      </td>
                      <td style={styles.td}>
                        <span style={styles.monoCell}>{error.invoice_number || "—"}</span>
                      </td>
                      <td style={styles.td}>{error.vendor || "—"}</td>
                      <td style={styles.td}>
                        <span style={styles.reasonBadge}>{error.reason}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        )}

      </main>
    </div>
  );
}

// ─────────────────────────────────────
// STYLES
// ─────────────────────────────────────
const styles = {

  page: {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },

  // ── HEADER ──
  header: {
    position: "fixed",
    top: 0, left: 0, right: 0,
    height: "56px",
    backgroundColor: "#0f172a",
    zIndex: 100,
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    display: "flex",
    alignItems: "center",
  },
  headerScrolled: { boxShadow: "0 1px 0 rgba(255,255,255,0.06)" },
  headerHidden:   { transform: "translateY(-100%)" },
  headerInner: {
    width: "100%", maxWidth: "1400px",
    margin: "0 auto", padding: "0 40px",
    display: "flex", alignItems: "center",
    justifyContent: "space-between", boxSizing: "border-box",
  },
  brand:         { display: "flex", alignItems: "center", gap: "12px" },
  logoWrap: {
    fontSize: "20px", width: "36px", height: "36px",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: "8px",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  brandTitle:    { fontSize: "14px", fontWeight: "700", color: "#ffffff", letterSpacing: "-0.01em" },
  brandSubtitle: { fontSize: "11px", color: "rgba(255,255,255,0.45)", fontWeight: "400", marginTop: "1px" },
  statusPill: {
    display: "flex", alignItems: "center", gap: "7px",
    padding: "5px 12px",
    backgroundColor: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: "999px",
  },
  statusDot: {
    width: "7px", height: "7px", borderRadius: "50%",
    backgroundColor: "#10b981",
    boxShadow: "0 0 0 3px rgba(16,185,129,0.20)",
  },
  statusText: { fontSize: "11px", fontWeight: "600", color: "rgba(255,255,255,0.70)", letterSpacing: "0.02em" },

  // ── MAIN ──
  main: {
    paddingTop: "80px", paddingBottom: "60px",
    paddingLeft: "40px", paddingRight: "40px",
    maxWidth: "1400px", margin: "0 auto",
    boxSizing: "border-box", width: "100%",
  },

  pageHeader:   { marginBottom: "24px" },
  eyebrowRow:   { display: "flex", alignItems: "center", gap: "7px", marginBottom: "10px" },
  eyebrowDot:   { width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#6366f1", boxShadow: "0 0 0 3px rgba(99,102,241,0.15)" },
  eyebrow:      { fontSize: "11px", fontWeight: "700", color: "#4f46e5", letterSpacing: "0.07em", textTransform: "uppercase" },
  eyebrowSep:   { fontSize: "11px", color: "#d1d5db" },
  eyebrowMuted: { fontSize: "11px", fontWeight: "600", color: "#9ca3af", letterSpacing: "0.07em", textTransform: "uppercase" },
  pageTitle:    { fontSize: "18px", fontWeight: "700", color: "#111827", margin: 0, letterSpacing: "-0.01em" },
  pageSubtitle: { fontSize: "13px", color: "#6b7280", margin: "4px 0 0 0", fontWeight: "400" },

  // ── SUCCESS BANNER ──
  successBanner: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "16px 20px",
    backgroundColor: "#f0fdf4",
    border: "1px solid #bbf7d0",
    borderRadius: "10px",
    marginBottom: "24px",
    flexWrap: "wrap",
  },
  successIconWrap: {
    width: "40px", height: "40px", borderRadius: "10px",
    backgroundColor: "#dcfce7",
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0,
  },
  successTitle: { fontSize: "14px", fontWeight: "700", color: "#14532d" },
  successHint:  { fontSize: "12px", color: "#16a34a", marginTop: "2px", fontWeight: "400" },
  bannerActions: { display: "flex", gap: "10px", marginLeft: "auto", flexWrap: "wrap" },

  downloadBtn: {
    height: "36px", padding: "0 18px",
    fontSize: "12px", fontWeight: "700",
    color: "#ffffff", backgroundColor: "#2563eb",
    border: "none", borderRadius: "7px",
    cursor: "pointer", whiteSpace: "nowrap",
    transition: "background-color 0.15s",
  },
  secondaryBtn: {
    height: "36px", padding: "0 18px",
    fontSize: "12px", fontWeight: "600",
    color: "#374151", backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb", borderRadius: "7px",
    cursor: "pointer", whiteSpace: "nowrap",
    transition: "background-color 0.15s",
  },

  // ── STATS GRID ──
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "14px",
    marginBottom: "28px",
  },
  statCard: {
    display: "flex", flexDirection: "column", gap: "4px",
    padding: "18px 16px",
    borderRadius: "10px", border: "1px solid #f3f4f6",
    boxSizing: "border-box",
  },
  statValue: {
    fontSize: "28px", fontWeight: "700",
    letterSpacing: "-0.02em", lineHeight: 1,
  },
  statLabel: {
    fontSize: "11px", fontWeight: "600", color: "#9ca3af",
    textTransform: "uppercase", letterSpacing: "0.05em", marginTop: "4px",
  },

  // ── ERROR SECTION ──
  errorSection: {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    overflow: "hidden",
  },
  errorSectionHeader: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
  },
  sectionHeaderLeft: { display: "flex", alignItems: "center", gap: "14px" },
  iconWrap: {
    width: "40px", height: "40px", borderRadius: "8px",
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  },
  cardTitle:   { fontSize: "14px", fontWeight: "700", color: "#111827", letterSpacing: "-0.01em" },
  cardSubtitle:{ fontSize: "12px", color: "#9ca3af", marginTop: "2px", fontWeight: "400" },
  errorCount: {
    fontSize: "11px", fontWeight: "700",
    color: "#dc2626", backgroundColor: "#fef2f2",
    padding: "3px 10px", borderRadius: "999px",
    border: "1px solid #fecaca",
  },
  divider: { height: "1px", backgroundColor: "#f3f4f6" },

  // ── TABLE ──
  tableWrap: {
    maxHeight: "420px",
    overflowY: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
  },
  th: {
    padding: "11px 16px",
    fontSize: "11px", fontWeight: "700",
    color: "#6b7280", textTransform: "uppercase",
    letterSpacing: "0.06em",
    backgroundColor: "#f9fafb",
    borderBottom: "1px solid #f3f4f6",
    textAlign: "left",
    position: "sticky", top: 0, zIndex: 1,
  },
  td: {
    padding: "11px 16px",
    fontSize: "12px", color: "#374151", fontWeight: "400",
    borderBottom: "1px solid #f9fafb",
    verticalAlign: "middle",
  },
  trEven: { backgroundColor: "#ffffff" },
  trOdd:  { backgroundColor: "#fafafa" },
  fileCell: {
    display: "flex", alignItems: "center", gap: "7px",
    fontWeight: "500", color: "#111827",
  },
  monoCell: {
    fontFamily: "ui-monospace, 'SF Mono', monospace",
    fontSize: "12px", color: "#4b5563",
    backgroundColor: "#f3f4f6",
    padding: "2px 7px", borderRadius: "4px",
  },
  reasonBadge: {
    display: "inline-block",
    padding: "3px 9px",
    backgroundColor: "#fef2f2",
    color: "#dc2626",
    fontSize: "11px", fontWeight: "600",
    borderRadius: "4px",
    border: "1px solid #fecaca",
  },
};